import { render, staticRenderFns } from "./role.vue?vue&type=template&id=b1220fca&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=b1220fca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1220fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1220fca')) {
      api.createRecord('b1220fca', component.options)
    } else {
      api.reload('b1220fca', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=b1220fca&scoped=true", function () {
      api.rerender('b1220fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systems/role.vue"
export default component.exports